<script lang="ts">
	import { format } from 'svelte-i18n';
	import { ButtonV2, Container, Modal, Text } from '@Shelly/shelly-design-system';
	import AppIcon from './Settings/AppSettings/AppIcon.svelte';
	import { mobile } from 'src/services/mobile-rework';
	import { createEventDispatcher, onMount } from 'svelte';
	import { save_home } from 'src/helpers/home_helpers';
	import { CHANGE_DATE } from 'src/constants';
	import { push } from 'svelte-spa-router';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let showModal = false;
	export let priority = 40;

	const dispatch = createEventDispatcher();

	const closeModal = (e: CustomEvent | MouseEvent) => {
		if (showModal) {
			e.preventDefault();
			console.log('saving home data');
			save_home('appIconModal', CHANGE_DATE.APP_ICON_MODAL);
			dispatch('close');
		}
	};

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', closeModal);
			return () => mobile.removeEventListener('back_button', closeModal);
		}
	});
</script>

<Modal {showModal} on:close={closeModal} hideTitle backdropClose={false} zIndex={priority}>
	<Container slot="content" padding="0" class="ml-s mr-s">
		<div class="mb-l d-flex align-items-center flex-direction-column">
			<Text class="mb-s" element="h1"
				>{$format('modal_title_app_icon_christmas', { default: 'Christmas App Icon' })}</Text
			>
			<Text class="text-center mb-m text-color-muted">
				{$format('modal_description_app_icon_christmas', {
					default:
						'Christmas is coming! We’ve introduced a new app icon for the Holiday season to keep you in the festive spirit.',
				})}
			</Text>

			<AppIcon isInModal={true} />
		</div>

		<div class="d-flex flex-direction-column align-items-center">
			{#if mobile.isMobile}
				<Text class="d-inline-block text-small">
					{$format('text_see_all_features', {
						default: 'If you want to see all the features by version',
					})}
					<Text
						class="d-inline-block link-styles text-small"
						on:click={(e) => {
							closeModal(e);
							push('/changelog');
						}}
					>
						{$format('click_here', { default: 'click here' })}
					</Text>
				</Text>
			{/if}
		</div>
	</Container>
	<div class="d-flex justify-content-end" slot="footer">
		<ButtonV2
			variant="primary"
			on:click={closeModal}
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s ml-s"
		>
			{$format('okay_got_it', { default: 'Okay, got it.' })}
		</ButtonV2>
	</div>
</Modal>
